<template>
  <div id="settings.profile" class="profile">
    <article>
      <p>
        {{ translate('Roles') }}
        <br />
        <span>{{ translate('Your assigned roles in Sphere') }}</span>
      </p>
      <div v-if="userStore.roles?.length" class="w-100 flex-grow-1">
        <DataTable
          :rows="sortedRoles"
          :cols-map="{Role: 'name', Direct: 'is_direct', Permissions: 'permissions'}"
          class="w-100 align-items-stretch"
        >
          <template #customCells="{row, cols}">
            <template v-for="(col, _) in cols" :key="_">
              <td v-if="col === 'name'" class="text-nowrap">
                <BootstrapBadge :variant="row.is_direct ? 'primary' : 'secondary'">
                  {{ row.name }}
                </BootstrapBadge>
              </td>
              <td v-if="col === 'is_direct'" class="text-nowrap">
                <BootstrapBadge :variant="row.is_direct ? 'primary' : 'secondary'">
                  {{ row.is_direct ? translate('Direct') : translate('Indirect') }}
                </BootstrapBadge>
              </td>
              <td v-if="col === 'permissions'">
                <div class="d-flex gap-1 flex-wrap">
                  <BootstrapBadge v-for="p in row[col]" :key="p.key" variant="secondary">
                    {{ p.description || p.key }}
                  </BootstrapBadge>
                  <span v-if="!row[col]?.length" class="text-secondary">—</span>
                </div>
              </td>
            </template>
          </template>
        </DataTable>
      </div>
      <span v-else>{{ translate('No roles assigned') }}</span>
    </article>
    <article>
      <p>
        {{ translate('Groups') }}
        <br />
        <span>
          {{ translate('Your assigned groups in Sphere') }}
        </span>
      </p>
      <div v-if="userStore.user?.groups?.length">
        <BootstrapBadge v-for="g in userStore.user.groups" :key="g.id" variant="secondary">
          {{ g.name }}
        </BootstrapBadge>
      </div>
      <p v-else>{{ translate('No groups assigned') }}</p>
    </article>
  </div>
</template>
<script lang="ts" setup>
import {useLocalisation} from '@/composables/useLocalisation';
const {translate} = useLocalisation();
const userStore = useUserStore();

const sortedRoles = computed(() =>
  [...(userStore.roles ?? [])].sort((a, b) => {
    if (a.is_direct !== b.is_direct) return a.is_direct ? -1 : 1;
    return a.name.localeCompare(b.name);
  }),
);
</script>
<style lang="scss" scoped>
.profile {
  article {
    display: flex;
    justify-content: space-between;
    margin-bottom: 1rem;

    div {
      display: flex;
      flex-wrap: wrap;
      align-items: start;
      gap: 0.5rem;
      width: 100%;

      span {
        white-space: normal;
        text-align: start;
      }
    }

    p {
      flex-basis: 20rem;
      margin-bottom: 0;

      span {
        font-size: 0.75rem;
        color: var(--bs-secondary);
      }
    }
  }
}
</style>
